/**
 * @author Toolito <toolito@90tech.fr>
 * @copyright 2015 Zenlabs SAS. All rights reserved.
 */
;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('chorusSettings', ChorusSettingsDirective)

  ChorusSettingsController.$inject = [
    // Angular
    '$window',
    // Libs
    // Managers
    'ChorusSettingManager',
    // Services
    'SnackService'
    // Const
    // Resolved
  ]

  function ChorusSettingsController (
    // Angular
    $window,
    // Libs
    // Managers
    ChorusSettingManager,
    // Services
    SnackService
    // Const
    // Resolved
  ) {
    const self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public attributes,
        loading: true,
        haveChorusDataFilled: false,
        chorusSetting: null,
        isUpdate: false,
        showPsswd: false,
        notValid: false,
        // Public methods
        sendCredentials
      })
      init()
    }

    function init () {
      if (!self.chorusAccess) return
      ChorusSettingManager.getSettings().then((response) => {
        if (response.data) {
          self.haveChorusDataFilled = true
          self.chorusSetting = ChorusSettingManager.build(response.data)
        }
        self.loading = false
        return self.loading
      }).catch(() => {
        self.loading = false
        return self.loading
      })
    }

    function sendCredentials () {
      self.loading = true
      const payload = {
        userMail: self.userMail,
        userPassword: self.userPasswd,
        userId: self.userId
      }
      if (self.isUpdate) {
        self.chorusSetting.updateCredentials(payload).then((response) => {
          if (response?.status === 200) {
            self.haveChorusDataFilled = true
            self.notValid = false
            SnackService.snack({
              text: `Vos identifiants ont été mis a jour`,
              delay: 5000
            })
          } else {
            // HTTP 400 here
            SnackService.snack({
              text: `Vos identifiants ne sont pas valides`,
              delay: 5000
            })
            self.notValid = true
          }
        }).catch(() => {
          SnackService.snack({
            text: `Vos identifiants ne sont pas valides`,
            delay: 5000
          })
          self.notValid = true
          self.loading = false
        }).finally(() => {
          self.loading = false
        })
      } else {
        ChorusSettingManager.saveCredentials(payload).then((response) => {
          if (response?.status === 201) {
            self.haveChorusDataFilled = true
            self.chorusSetting = ChorusSettingManager.build(response.data)
            self.notValid = false
            SnackService.snack({
              text: `Vos identifiants ont été validé et enregistrés`,
              delay: 5000
            })
          } else {
            // HTTP 400 here
            SnackService.snack({
              text: `Vos identifiants ne sont pas valides`,
              delay: 5000
            })
            self.notValid = true
          }
        }).catch(() => {
          SnackService.snack({
            text: `Vos identifiants ne sont pas valides`,
            delay: 5000
          })
          self.notValid = true
          self.loading = false
        }).finally(() => {
          self.loading = false
        })
      }
    }
  }

  ChorusSettingsDirective.$inject = []

  /**
     * Common directive used to popup a user card on event
     * @type Directive
     * @returns {{restrict: string, templateUrl: string, controller: ChorusSettingsController, controllerAs: string, link: link, scope: {user: string, event: string}}}
     * @constructor
     */
  function ChorusSettingsDirective () {
    return {
      restrict: 'E',
      templateUrl: '/app/common/directives/chorus-settings/chorus-settings.directive.html',
      controller: ChorusSettingsController,
      controllerAs: '$ctrl',
      scope: {},
      bindToController: {
        chorusAccess: '='
      }
    }
  }
})(window.angular, window._)
